"use client"

import { ProfileMenuSubTrigger } from "@/components/profile-menu-sub-trigger"
import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
} from "@/components/ui/dropdown-menu"
import {
  usePrismNavMode,
  type PrismNavMode,
} from "@/hooks/use-prism-nav-mode"
import { isProductEntitled } from "@/lib/mock/product-catalog"
import { useProduct } from "@/contexts/product-context"

const OPTIONS: { id: PrismNavMode; label: string; description: string }[] = [
  {
    id: "launcher",
    label: "Module launcher",
    description: "Dashboard grid with program, curriculum, and placement modules.",
  },
  {
    id: "sidebar",
    label: "Sidebar navigation",
    description: "Hide the launcher. Show every module in the primary sidebar.",
  },
]

export function PrismNavModeMenu() {
  const { product } = useProduct()
  const [mode, setMode] = usePrismNavMode()

  if (
    product !== "exxat-prism" &&
    product !== "exxat-custom" &&
    !isProductEntitled("exxat-prism")
  ) {
    return null
  }

  const active = OPTIONS.find(option => option.id === mode)

  return (
    <DropdownMenuSub>
      <ProfileMenuSubTrigger
        iconClassName="fa-light fa-table-columns"
        label="Clinical Education navigation"
        trailing={active?.label}
      />
      <DropdownMenuSubContent className="w-64">
        <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
          Navigation layout
        </DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={mode}
          onValueChange={value => {
            const next = value as PrismNavMode
            if (next === mode) return
            setMode(next)
            window.location.reload()
          }}
        >
          {OPTIONS.map(option => (
            <DropdownMenuRadioItem
              key={option.id}
              value={option.id}
              className="items-start gap-2 py-2"
            >
              <span className="flex flex-col gap-0.5">
                <span className="font-medium">{option.label}</span>
                <span className="text-xs leading-snug text-muted-foreground">
                  {option.description}
                </span>
              </span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
